/**
 * Created by Languagenut on 18/03/2020.
 */

import React from 'react'

import ReactGA from 'react-ga';

export default class Success extends React.Component {
    constructor(props) {
        super();
        this.state = {
            gotTranslations: false,
            authenticated: false
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        ReactGA.pageview(window.location.pathname + window.location.hash);
    }

    render() {
        return <div class="jumbotron text-center">
            <h1 class="display-4">Thank You!<br /><small><small></small></small></h1>
            <p class="lead">Your order is being processed and your logins will be emailed to you shortly.</p>
            <b>Please make sure you check both your <span style={{ textDecoration: 'underline' }}>spam</span> and <span style={{ textDecoration: 'underline' }}>junk</span> folders for your login credentials</b>
            <hr />
            <p>
                For any questions email us on <a href="mailto:home@languagenut.com">home@languagenut.com</a>
            </p>
            <img height="80px" src="https://s3-eu-west-1.amazonaws.com/marketing.languagenut.com/Sales%20site/Languagenut%20Sales%20Sites%20Image%20Assets/LN%20Logo.png" />
        </div>
    }
}
